function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import values from 'ramda/src/values';
export var RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS = {
  BEGIN: 'RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_BEGIN',
  SUCCESS: 'RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_SUCCESS',
  FAILURE: 'RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_FAILURE'
};
export var RETRIEVE_CONVERGENT_BILLER_INVOICES_CONSTANTS = {
  BEGIN: 'RETRIEVE_CONVERGENT_BILLER_INVOICES_BEGIN',
  SUCCESS: 'RETRIEVE_CONVERGENT_BILLER_INVOICES_SUCCESS',
  FAILURE: 'RETRIEVE_CONVERGENT_BILLER_INVOICES_FAILURE'
};
export var RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_CONSTANTS = {
  BEGIN: 'RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_FAILURE'
};
export var CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_CONSTANTS = {
  BEGIN: 'CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_BEGIN',
  SUCCESS: 'CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_SUCCESS',
  FAILURE: 'CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_FAILURE'
};
export var REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_SCHEDULE_CONSTANTS = {
  BEGIN: 'REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_BEGIN',
  SUCCESS: 'REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_SUCCESS',
  FAILURE: 'REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_FAILURE'
};
export var RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_CONSTANTS = {
  BEGIN: 'RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_FAILURE'
};
export var RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_CONSTANTS = {
  BEGIN: 'RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_FAILURE'
};
export var RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_CONSTANTS = {
  BEGIN: 'RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_FAILURE'
};
export var RETRIEVE_SUBSCRIBER_DEPOSITS_CONSTANTS = {
  BEGIN: 'RETRIEVE_SUBSCRIBER_DEPOSITS_CONSTANTS_BEGIN',
  SUCCESS: 'RETRIEVE_SUBSCRIBER_DEPOSITS_CONSTANTS_SUCCESS',
  FAILURE: 'RETRIEVE_SUBSCRIBER_DEPOSITS_CONSTANTS_FAILURE'
};
export var UPDATE_SUBSCRIBER_TREATMENT_CONSTANTS = {
  BEGIN: 'UPDATE_SUBSCRIBER_TREATMENT_CONSTANTS_BEGIN',
  SUCCESS: 'UPDATE_SUBSCRIBER_TREATMENT_CONSTANTS_SUCCESS',
  FAILURE: 'UPDATE_SUBSCRIBER_TREATMENT_CONSTANTS_FAILURE'
};
var RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_EVENTS = [RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS.BEGIN, RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS.SUCCESS, RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_CONSTANTS.FAILURE];
var RETRIEVE_CONVERGENT_BILLER_INVOICES_EVENTS = [RETRIEVE_CONVERGENT_BILLER_INVOICES_CONSTANTS.BEGIN, RETRIEVE_CONVERGENT_BILLER_INVOICES_CONSTANTS.SUCCESS, RETRIEVE_CONVERGENT_BILLER_INVOICES_CONSTANTS.FAILURE];
var RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_EVENTS = [RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_CONSTANTS.BEGIN, RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_CONSTANTS.SUCCESS, RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_CONSTANTS.FAILURE];
var CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_EVENTS = [CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_CONSTANTS.BEGIN, CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_CONSTANTS.SUCCESS, CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_CONSTANTS.FAILURE];
var REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_SCHEDULE = [REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_SCHEDULE_CONSTANTS.BEGIN, REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_SCHEDULE_CONSTANTS.SUCCESS, REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_SCHEDULE_CONSTANTS.FAILURE];
var RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_EVENTS = [RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_CONSTANTS.BEGIN, RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_CONSTANTS.SUCCESS, RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_CONSTANTS.FAILURE];
var RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_EVENTS = [RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_CONSTANTS.BEGIN, RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_CONSTANTS.SUCCESS, RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_CONSTANTS.FAILURE];
var RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_EVENTS = [RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_CONSTANTS.BEGIN, RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_CONSTANTS.SUCCESS, RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_CONSTANTS.FAILURE];
var RETRIEVE_SUBSCRIBER_DEPOSITS_EVENTS = [RETRIEVE_SUBSCRIBER_DEPOSITS_CONSTANTS.BEGIN, RETRIEVE_SUBSCRIBER_DEPOSITS_CONSTANTS.SUCCESS, RETRIEVE_SUBSCRIBER_DEPOSITS_CONSTANTS.FAILURE];
var UPDATE_SUBSCRIBER_TREATMENT_EVENTS = [UPDATE_SUBSCRIBER_TREATMENT_CONSTANTS.BEGIN, UPDATE_SUBSCRIBER_TREATMENT_CONSTANTS.SUCCESS, UPDATE_SUBSCRIBER_TREATMENT_CONSTANTS.FAILURE];
export var SET_ORDER_ITEM_TO_DISPLAY_SERVICE_ATTRIBUTES_FOR = 'SET_ORDER_ITEM_TO_DISPLAY_SERVICE_ATTRIBUTES_FOR';
export var retrieveConvergentBillerSubscriberSummaryPromise = function retrieveConvergentBillerSubscriberSummaryPromise(dispatch, customerId) {
  var includePaymentInstrumentAssociations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return ThunkHelper(dispatch, RETRIEVE_CONVERGENT_BILLER_SUBSCRIBER_SUMMARY_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerSubscriberSummary',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      IncludePaymentInstrumentAssociations: includePaymentInstrumentAssociations
    }
  }, {
    customerId: customerId
  });
};
export var retrieveConvergentBillerSubscriberSummary = function retrieveConvergentBillerSubscriberSummary(customerId) {
  var includePaymentInstrumentAssociations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    return retrieveConvergentBillerSubscriberSummaryPromise(dispatch, customerId, includePaymentInstrumentAssociations);
  };
};
export var retrieveConvergentBillerInvoicesPromise = function retrieveConvergentBillerInvoicesPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_CONVERGENT_BILLER_INVOICES_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerInvoices',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveSusbcriberDepositsPromise = function retrieveSusbcriberDepositsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_SUBSCRIBER_DEPOSITS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerSubscriberDeposits',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveConvergentBillerTreatmentDetailsPromise = function retrieveConvergentBillerTreatmentDetailsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_CONVERGENT_BILLER_TREATMENT_DETAILS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerSubscriberTreatmentDetails',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveConvergentBillerTreatmentDetails = function retrieveConvergentBillerTreatmentDetails(customerId) {
  return function (dispatch) {
    return retrieveConvergentBillerTreatmentDetailsPromise(dispatch, customerId);
  };
};
export var createConvergentBillerPromiseToPaySchedulePromise = function createConvergentBillerPromiseToPaySchedulePromise(dispatch, customerId, promiseToPayScheduleRequest) {
  return ThunkHelper(dispatch, CREATE_CONVERGENT_BILLER_PROMISE_TO_PAY_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/CreateConvergentBillerPromiseToPaySchedule',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: promiseToPayScheduleRequest
  });
};
export var createConvergentBillerPromiseToPaySchedule = function createConvergentBillerPromiseToPaySchedule(customerId, promiseToPayScheduleRequest) {
  return function (dispatch) {
    return createConvergentBillerPromiseToPaySchedulePromise(dispatch, customerId, promiseToPayScheduleRequest);
  };
};
export var removePromiseToPaySchedulePromise = function removePromiseToPaySchedulePromise(dispatch, customerId) {
  return ThunkHelper(dispatch, REMOVE_CONVERGENT_BILLER_PROMISE_TO_PAY_SCHEDULE, {
    method: 'post',
    url: 'SubscriberManagement/CancelConvergentBillerPromiseToPaySchedule',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {}
  });
};
export var removePromiseToPaySchedule = function removePromiseToPaySchedule(customerId) {
  return function (dispatch) {
    return removePromiseToPaySchedulePromise(dispatch, customerId);
  };
};
export var retrieveConvergentBillerAccountDetailsPromise = function retrieveConvergentBillerAccountDetailsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_CONVERGENT_BILLER_ACCOUNT_DETAILS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerAccountDetails',
    data: {},
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveConvergentBillerAccountDetails = function retrieveConvergentBillerAccountDetails(customerId) {
  return function (dispatch) {
    return retrieveConvergentBillerAccountDetailsPromise(dispatch, customerId);
  };
};
export var retrieveConvergentBillerAccountUsageDetailsPromise = function retrieveConvergentBillerAccountUsageDetailsPromise(dispatch, customerId, requestObj) {
  return ThunkHelper(dispatch, RETRIEVE_CONVERGENT_BILLER_ACCOUNT_USAGE_DETAILS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerAccountUsageDetails',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: requestObj
  }, {
    customerId: customerId,
    serviceId: requestObj.ServiceIdentifier ? requestObj.ServiceIdentifier.Value : ''
  });
};
export var retrieveConvergentBillerAccountUsageDetails = function retrieveConvergentBillerAccountUsageDetails(data) {
  return function (dispatch) {
    return retrieveConvergentBillerAccountUsageDetailsPromise(dispatch, data.customerId, data.request);
  };
};
export var retrieveConvergentBillerOrderDetailsPromise = function retrieveConvergentBillerOrderDetailsPromise(dispatch, customerId, orderId) {
  return ThunkHelper(dispatch, RETRIEVE_CONVERGENT_BILLER_ORDER_DETAILS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrder',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      OrderId: orderId
    }
  }, {
    customerId: customerId,
    orderId: orderId
  });
};
export var retrieveConvergentBillerOrderDetails = function retrieveConvergentBillerOrderDetails(customerId, orderId) {
  return function (dispatch) {
    return retrieveConvergentBillerOrderDetailsPromise(dispatch, customerId, orderId);
  };
};
export var updateSubscriberTreatmentPromise = function updateSubscriberTreatmentPromise(dispatch, customerId, treatmentAction, deescalationDate) {
  return ThunkHelper(dispatch, UPDATE_SUBSCRIBER_TREATMENT_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateSubscriberTreatment',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      TreatmentAction: treatmentAction,
      DeescalationDate: deescalationDate
    }
  });
};
export var updateSubscriberTreatment = function updateSubscriberTreatment(customerId, treatmentAction, deescalationDate) {
  return function (dispatch) {
    return updateSubscriberTreatmentPromise(dispatch, customerId, treatmentAction, deescalationDate);
  };
};
export var setOrderItemToDisplayServiceAttributesFor = function setOrderItemToDisplayServiceAttributesFor(itemId) {
  return {
    type: SET_ORDER_ITEM_TO_DISPLAY_SERVICE_ATTRIBUTES_FOR,
    payload: itemId
  };
};
export var UPDATE_DASHBOARD_ENTITLEMENT_SHARE_STATUS = {
  BEGIN: 'UPDATE_DASHBOARD_ENTITLEMENT_SHARE_STATUS_BEGIN',
  SUCCESS: 'UPDATE_DASHBOARD_ENTITLEMENT_SHARE_STATUS_SUCCESS',
  FAILURE: 'UPDATE_DASHBOARD_ENTITLEMENT_SHARE_STATUS_FAILURE'
};
export var updateDashboardEntitlementShareStatus = function updateDashboardEntitlementShareStatus(customerId, entitlementIdentifier, shareStatus) {
  return function (dispatch) {
    return ThunkHelper(dispatch, Object.values(UPDATE_DASHBOARD_ENTITLEMENT_SHARE_STATUS), {
      method: 'post',
      url: 'SubscriberManagement/UpdateEntitlementShareStatus',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: {
        SharedStatus: shareStatus,
        EntitlementIdentifier: entitlementIdentifier
      }
    });
  };
};